import React, { useState, useEffect, useCallback } from "react";
import { apiGetGerente, apiGetGerentePDF } from "../../../lib/apiPaseLista";
import Cultivo from "./cultivo";
import moment from "moment";
import DateTime from "react-datetime";
import { NotificationManager } from "react-notifications";
import FileSaver from "file-saver";
import useLoading from "../../../hooks/useLoading";

import { useLocation } from "react-router-dom";
import RevisionGerente from "./RevisionGerente"; 

const Gerente = () => {
  const loading = useLoading();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("revision_tarjetas"); 

  const [info, setInfo] = useState({
    cultivos: [],
    total: 0,
  });
  const [selectedDate, setSelectedDate] = useState(moment());

  useEffect(() => {
    async function getGerente() {
      if (activeTab === "horas_extra") {
        const resp = await apiGetGerente({
          fecha: selectedDate.format("yyyy-MM-DD"),
        });
        setInfo(resp);
      }
    }
    getGerente();
  }, [selectedDate, activeTab]);

  const valid = (current) => {
    const today = moment().endOf("day");
    return today.isSameOrAfter(current);
  };

  const getPDF = useCallback(async () => {
    loading.set();
    try {
      const resp = await apiGetGerentePDF({
        fecha: selectedDate.format("yyyy-MM-DD"),
      });

      const contentType = resp.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const respObj = await resp.json();
        if (respObj.error) {
          NotificationManager.error(
            "Ocurrió un error. Inténtelo más tarde.",
            "",
            5000
          );
        }
      } else {
        const file = await resp.blob();
        FileSaver.saveAs(file, "horasExtra.pdf");
      }
    } catch (error) {
      console.error(error);
      NotificationManager.error(
        "Ocurrió un error. Inténtelo más tarde.",
        "",
        5000
      );
    }
    loading.stop();
  }, [selectedDate, loading]);

  return (
    <div>
      <div className="page-title mb-3">
        <h3>
          <i className="fas fa-clipboard-list" /> Gerente
        </h3>
      </div>

      <div className="mb-4">
        <div 
          className="d-inline-flex p-1 rounded shadow-sm" 
          style={{ backgroundColor: "#e2e6ea" }}
        >
          <button
            className={`btn border-0 font-weight-bold px-4 py-2 m-0 ${
              activeTab === "revision_tarjetas" ? "bg-white text-danger shadow-sm" : "text-muted bg-transparent"
            }`}
            style={{ borderRadius: "0.3rem", transition: "all 0.2s ease-in-out", outline: "none" }}
            onClick={() => setActiveTab("revision_tarjetas")}
          >
            <i className="fas fa-exclamation-triangle mr-2" />
            Revisión de Tarjetas
          </button>

          <button
            className={`btn border-0 font-weight-bold px-4 py-2 m-0 ${
              activeTab === "horas_extra" ? "bg-white text-primary shadow-sm" : "text-muted bg-transparent"
            }`}
            style={{ borderRadius: "0.3rem", transition: "all 0.2s ease-in-out", outline: "none" }}
            onClick={() => setActiveTab("horas_extra")}
          >
            <i className="fas fa-clock mr-2" />
            Horas Extra
          </button>
        </div>
      </div>

      {activeTab === "revision_tarjetas" && (
        <div className="tab-pane fade show active">
          <RevisionGerente />
        </div>
      )}

      {activeTab === "horas_extra" && (
        <div className="tab-pane fade show active">
          <div className="row">
            <div className="col-md-6">
              <div
                className="card card-body"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div style={{ flex: 1, marginRight: "1rem" }}>
                  <DateTime
                    closeOnSelect={true}
                    dateFormat="DD/MMM/YYYY"
                    placeholder="seleccione fecha"
                    timeFormat={false}
                    onChange={(date) => setSelectedDate(moment(date))}
                    value={selectedDate}
                    viewMode="days"
                    locale="es"
                    isValidDate={valid}
                    inputProps={{
                      required: true,
                      className: "form-control limit",
                    }}
                  />
                </div>

                <button type="button" className="btn btn-success" onClick={getPDF}>
                  Generar PDF
                </button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card card-body">
                <h5>
                  <small>Total de horas extras: </small>
                  {info.total}
                </h5>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="row">
                {!info.cultivos.length && (
                  <div className="col-12">
                    <div className="card" style={{ marginTop: ".5rem" }}>
                      <div className="card-body">
                        Sin cultivos en la fecha seleccionada
                      </div>
                    </div>
                  </div>
                )}
                {info.cultivos.map((c) => (
                  <Cultivo
                    key={c.id}
                    cultivo={{
                      sys21_id: c.id,
                      nombre_cultivo: c.nombre,
                      total: c.total,
                      actividades: c.actividades.map((a) => ({
                        sys21_id: a.id_actividad,
                        nombre: a.nombre,
                        total: a.total,
                        trabajadores: a.num_trabajadores || 0,
                      })),
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gerente;